import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import store from "../../redux/store/store";

const buildTranslationMap = (translations = []) => {
  const translationMap = {};

  translations.forEach((item) => {
    translationMap[item.fieldname] = item.translation;
  });

  return translationMap;
};

export const getScreenTranslations = async (
  screenName,
  options = { language: null, companyid: null },
) => {
  const reduxStore = store;
  const languages = reduxStore.getState()?.user?.allScreenTrnslations || {};

  if (Array.isArray(languages[screenName])) {
    return Promise.resolve(languages[screenName]);
  }

  const payload = {
    screenname: screenName,
    language: options.language || window.localStorage.getItem("language"),
    companyid: options.companyid || window.localStorage.getItem("companyid"),
  };
  const data = await axiosInstance.post(
    `${API_URL}/api/User/FetchTranslationData`,
    payload,
  );
  if (data.status === 200) {
    reduxStore.dispatch({
      type: "SET_ALLSCREEN_TRANSLATION",
      data: { screenName: screenName, translations: data.data.data },
    });
    return Promise.resolve(data.data.data);
  }
};

// export const fetchScreenTranslations = async (
//   screenName,
//   options = { language: null, companyid: null },
// ) => {
//   const reduxStore = store;
//   const languages = reduxStore.getState()?.user?.allScreenTrnslations || {};

//   if (languages[screenName]) {
//     return Promise.resolve(languages[screenName]);
//   } else {
//     const payload = {
//       screenname: screenName,
//       language: options.language || window.localStorage.getItem("language"),
//       companyid: options.companyid || window.localStorage.getItem("companyid"),
//     };
//     const data = await axiosInstance.post(
//       `${API_URL}/api/User/FetchTranslationData`,
//       payload,
//     );
//     if (data.status === 200) {
//       const translationsArray = data.data.data;

//       // Converted array → object
//       const translationMap = {};
//       translationsArray.forEach((item) => {
//         translationMap[item.fieldname] = item.translation;
//       });

//       reduxStore.dispatch({
//         type: "SET_ALLSCREEN_TRANSLATION",
//         data: {
//           screenName: screenName,
//           translations: translationMap, // store map instead of array
//         },
//       });

//       return Promise.resolve(translationMap);
//     }
//   }
// };

export const fetchScreenTranslations = async (
  screenName,
  options = { language: null, companyid: null },
) => {
  const reduxStore = store;
  const languages = reduxStore.getState()?.user?.allScreenTrnslations || {};

  if (languages[screenName]) {
    const cached = languages[screenName];

    if (Array.isArray(cached)) {
      return Promise.resolve(buildTranslationMap(cached));
    }

    return Promise.resolve(cached);
  }

  const payload = {
    screenname: screenName,
    language: options.language || window.localStorage.getItem("language"),
    companyid: options.companyid || window.localStorage.getItem("companyid"),
  };
  const data = await axiosInstance.post(
    `${API_URL}/api/User/FetchTranslationData`,
    payload,
  );
  if (data.status === 200) {
    const translationsArray = data.data.data;

    reduxStore.dispatch({
      type: "SET_ALLSCREEN_TRANSLATION",
      data: {
        screenName: screenName,
        translations: translationsArray,
      },
    });

    return Promise.resolve(buildTranslationMap(translationsArray));
  }
};
